import axios from 'axios'
import { Toast } from 'vant'
import { axiosConfig } from './config'
import { requestResolve } from './requestHandler'
import { responseResolve } from './responseHandler'
import { errorHandler } from './errorHandler'

const service = axios.create(axiosConfig)

// 请求拦截器
service.interceptors.request.use(requestResolve, errorHandler)

// 响应拦截器
service.interceptors.response.use(responseResolve, errorHandler)

export function httpGet({ url = '', params = {}, isLoad = true } = {}) {
  let loading
  if (isLoad) {
    loading = Toast.loading({
      message: '加载中...',
      forbidClick: true,
      duration: 0
    })
  }
  return new Promise((resolve, reject) => {
    service.get(url, { params })
      .then(res => {
        loading && loading.clear()
        resolve(res)
      }).catch(err => {
        loading && loading.clear()
        reject(err)
      })
  })
}
export function httpPost({ url = '', data = {}, isLoad = true } = {}) {
  let loading
  if (isLoad) {
    loading = Toast.loading({
      message: '加载中...',
      forbidClick: true,
      duration: 0
    })
  }
  return new Promise((resolve, reject) => {
    service.post(url, data)
      .then(res => {
        loading && loading.clear()
        resolve(res)
      }).catch(err => {
        loading && loading.clear()
        reject(err)
      })
  })
}
